/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface BankAccount
 */
export interface BankAccount {
    /**
     * 
     * @type {string}
     * @memberof BankAccount
     */
    owner: string;
    /**
     * 
     * @type {string}
     * @memberof BankAccount
     */
    iban: string;
    /**
     * 
     * @type {string}
     * @memberof BankAccount
     */
    bic: string;
    /**
     * 
     * @type {string}
     * @memberof BankAccount
     */
    bank: string;
}

/**
 * Check if a given object implements the BankAccount interface.
 */
export function instanceOfBankAccount(value: object): value is BankAccount {
    if (!('owner' in value) || value['owner'] === undefined) return false;
    if (!('iban' in value) || value['iban'] === undefined) return false;
    if (!('bic' in value) || value['bic'] === undefined) return false;
    if (!('bank' in value) || value['bank'] === undefined) return false;
    return true;
}

export function BankAccountFromJSON(json: any): BankAccount {
    return BankAccountFromJSONTyped(json, false);
}

export function BankAccountFromJSONTyped(json: any, ignoreDiscriminator: boolean): BankAccount {
    if (json == null) {
        return json;
    }
    return {
        
        'owner': json['owner'],
        'iban': json['iban'],
        'bic': json['bic'],
        'bank': json['bank'],
    };
}

export function BankAccountToJSON(json: any): BankAccount {
    return BankAccountToJSONTyped(json, false);
}

export function BankAccountToJSONTyped(value?: BankAccount | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'owner': value['owner'],
        'iban': value['iban'],
        'bic': value['bic'],
        'bank': value['bank'],
    };
}

